// hooks/useProductCard.js - Product Card Hook
import { useMemo } from 'react';
import { calculate_price_without_dis, hasDiscount } from '../../../helper';

const useProductCard = ({ product, gold }) => {
  const discounted = useMemo(() => {
    return typeof product['discount'] !== 'undefined' ? hasDiscount(product['discount']) : false;
  }, [product]);

  const product_price_without = useMemo(() => {
    if (discounted) {
      return calculate_price_without_dis(gold, product['formula'], product['products']['accounting_weight'], 0);
    }
    return 0;
  }, [discounted, gold, product]);

  const productUrl = useMemo(() => {
    console.log({ product });
    return `/products/${product?.products?.album_id}/${product['products']['accounting_name_product']?.split(' ')?.join('-')}?weight=${product['products'].weight}?barcode=${product['products'].accounting_barcode}`;
  }, [product]);

  return {
    discounted,
    product_price_without,
    productUrl,
  };
};

export default useProductCard;
